import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { PanelModule } from 'primeng/panel';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-lead-form',
  imports: [SharedModule, PanelModule],
  templateUrl: './lead-form.component.html',
  styleUrl: './lead-form.component.scss'
})
export class LeadFormComponent {

  @ViewChild('leadForm') leadForm!: NgForm;

  isFixedColumn = true;
  isSubmitted = false;
  btnLoading = false;
  successMessage = false;
  dataLoading = false;
  loading = false;
  allLeadFeilds: any[] = [];
  copyOfFields: any = {};

  createFieldFormValue: any = {
    company_name: '',
    // contact_name: '',
    first_name: '',
    last_name: '',
    prefix: '',
    email: '',
    phone: ''
  };

  prefixOptions: any[] = [
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Ms.', value: 'Ms.' },
    { label: 'Mrs.', value: 'Mrs.' },
    { label: 'Dr.', value: 'Dr.' },
    { label: 'Prof.', value: 'Prof.' }
  ];

  fieldValues: any = {};

  constructor(private localStorage: LocalStorageService,
    private api: LeadService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) { }

  campusId: any;
  organizationId: any;

  ngOnInit() {
    
    let key = this.route.snapshot.params['key'];
    let decryptedData = this.decrypt(key);

    this.campusId = decryptedData.campusId;
    this.organizationId = decryptedData.organizationId;

    this.getLeadsFields();

  }

  private readonly key = 'mySafeKey123'; // must match on decrypt too

  private toBase64UrlSafe(base64: string): string {
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  private fromBase64UrlSafe(urlSafe: string): string {
    let base64 = urlSafe.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
      base64 += '=';
    }
    return base64;
  }

  encrypt(data: any): string {
    const jsonStr = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonStr, this.key).toString();
    return this.toBase64UrlSafe(encrypted);
  }

  decrypt(ciphertext: string): any {
    const base64 = this.fromBase64UrlSafe(ciphertext);
    const bytes = CryptoJS.AES.decrypt(base64, this.key);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedStr);
  }

  getLeadsFields() {

    let param = {
      organization_id: this.organizationId,
      campus_id: this.campusId,
    };
    this.dataLoading = true;
    this.api.getLeadsFields(param).subscribe(
      (data: any) => {
        this.dataLoading = false;
        this.allLeadFeilds = data.fields || [];

        // where is_public is true 
        this.allLeadFeilds = this.allLeadFeilds.filter((field: any) => field.is_public == true);
        console.log(this.allLeadFeilds, 'allLeadFeilds');
      },
      (error: any) => {
        this.dataLoading = false;
        this.loading = false;
        this.messageService.add({
          severity: 'error', summary: 'Error', detail: (error.error.message ||
            'Something went wrong, Please try again later.'
          )
        });
      }
    );
  }

  isValidEmail(email: string, form: NgForm, name: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  scrollToError(form: NgForm, container: HTMLElement) {
    const invalidControl = container.querySelector('.ng-invalid');
    if (invalidControl) {
      invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  SaveLead(isValid: boolean) {
    this.isSubmitted = true;
    if (!isValid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
      return;
    }

    this.btnLoading = true;

    this.isSubmitted = true;
    this.btnLoading = true;
    this.createFieldFormValue.campus_id = this.campusId
    this.createFieldFormValue.organization_id = this.organizationId;
    this.createFieldFormValue.dynamic_fields = this.fieldValues;
    this.createFieldFormValue.source = 'Website';
    this.createFieldFormValue.lead_type = 'New Lead';
    this.createFieldFormValue.query_type = 'General';
    this.createFieldFormValue.lead_status = 'Raw'
    this.createFieldFormValue.current_stage = 'lead';
    this.createFieldFormValue.lead_date = moment().format('YYYY-MM-DD');
    this.createFieldFormValue.lead_time = moment().format('HH:mm');

    this.api.addLeadData(this.createFieldFormValue).subscribe({
      next: (c) => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Added Successfully' });
        this.createFieldFormValue = {};
        this.fieldValues = {};
        this.isSubmitted = false;
        this.successMessage = true;
        this.leadForm.resetForm();
      }
      , error: (e) => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: (e.error.message || 'Something went wrong') });
      }
    });


  }

}
